import Button from '@mui/material/Button'
import MenuItem from '@mui/material/MenuItem'
import IconButton from '@mui/material/IconButton'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { useState, MouseEvent, ReactNode, memo } from 'react'
import MuiMenu, { MenuProps } from '@mui/material/Menu'

type ComponentProps = Omit<MenuProps, 'open'> & {
  name: string
  icon?: ReactNode
  btnLabel?: string
  isLoading?: boolean
  items: Array<{ label: string; icon?: ReactNode; onClick: (event: MouseEvent) => void }>
}

function Menu(props: ComponentProps): JSX.Element {
  const {
    name,
    items,
    btnLabel,
    isLoading = false,
    icon = btnLabel ? undefined : <MoreVertIcon />,
    ...menuProps
  } = props
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => setAnchorEl(null)

  return (
    <>
      {!icon ? (
        <Button
          sx={{ color: '#a1a1a1', fontSize: 14 }}
          aria-controls="simple-menu"
          aria-haspopup="true"
          disabled={isLoading}
          onClick={handleClick}
        >
          {btnLabel}
        </Button>
      ) : (
        <IconButton
          sx={{ color: '#fff', fontSize: 14 }}
          size="small"
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <>
            {btnLabel}
            {icon}
          </>
        </IconButton>
      )}

      <MuiMenu {...menuProps} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {items.map((item, idx) => (
          <MenuItem
            key={`${name}-menu-item-${idx}`}
            onClick={(e: MouseEvent) => {
              e.stopPropagation()
              item.onClick(e)
              handleClose()
            }}
          >
            {item.icon ? (
              <>
                {item.icon}
                {item.label}
              </>
            ) : (
              item.label
            )}
          </MenuItem>
        ))}
      </MuiMenu>
    </>
  )
}

export default memo(Menu)
